export var VERSION = '1.18.7';
//# sourceMappingURL=version.js.map